import { orchestrator } from 'satcheljs';
import { logUsage as logUsageAction } from 'owa-analytics-actions';
import { logUsage } from '../api';

orchestrator(logUsageAction, actionMessage => {
    logUsage(actionMessage.eventName, actionMessage.customData, actionMessage.options);
});
